import axios from 'axios';
import urlJoin from 'url-join';

/**
 * Estima API service.
 */
export default class EstimaService {
    /**
     * Retrieve estima information of given id.
     * @param {Integer} id Estima id
     * @return {Promise<Object>} Estima information
     */
    static getEstima(id) {
        return axios.get(urlJoin(MA.Config.API_URL, `/${encodeURIComponent(id)}`), {
            headers: { Accept: 'application/json' },
        });
    }
}
